import { Record } from '@/domains/work';
import { Load } from '@/domains/system';
import { export_json_to_excel } from '@/vendor/Export2Excel';
import TemplatesExcelUtil from '@/utils/excel/template/TemplateExcelUtil';

/**
 * 理论课档案Excel
 */
export default class TheoryTemplateExcelUtil2 extends TemplatesExcelUtil {

  public static exportExcel(datas: Record[]) {
    Load.startFullLoad('正在导出理论课2档案');

    // 档案标题头
    const headers: string[] = [];
    // 档案标题头（格式化）
    const formatHeaders: string[] = [];

    // Excel数据列表
    const excelList: any[] = this.toExccelData(datas, headers);
    // Excel数据列表（格式化）
    const formatData: any[] = this.format(excelList, headers, formatHeaders);

    export_json_to_excel({
      header: formatHeaders,
      data: formatData,
      filename: '听课档案列表(理论课2)' + new Date().getTime(),
      autoWidth: true,
    });
  }

  /**
   * 格式化
   *
   * @param datas Excel数据列表
   * @param headers Excel表头列表
   * @param formatHeaders Excel表头列表（格式化）
   */
  private static format(datas: any[], headers: string[], formatHeaders: string[]) {
    const order = [
      0, 72, 1, -1, -1, 2, 3, 4, 7, 5, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20,
      21, 22, 40, 41, 42, 23, 43, 44, 45, 46, 47, 24, 48, 49, 50, 51, 52, 53, 54,
      25, 55, 56, 57, 58, 59, 60, 26, 61, 62, 63, 27, 64, 65, 28, 66, 67, 68, 69,
      70, 30, 31, 19, 32, 33, 34, 35, 36, 37, 38, 39, 29, 75, 71, 75, -1, 6, 73,
      74, 76, 77, 78, 79, 80, 81, 81, 82,
    ];

    const list: string[][] = [];

    console.log(headers);

    let i = 0;
    headers.forEach((header) => {
      if (order[i] !== -1) {
        formatHeaders[order[i]] = header;
      }
      i++;
    });

    console.log(datas);

    i = 0;
    datas.forEach((subs: string[]) => {
      let j = 0;
      const temp: string[] = [];
      subs.forEach((data: string) => {
        if (order[j] !== -1) {
          temp[order[j]] = data;
        }
        j++;
      });
      list.push(temp);
      i++;
    });
    return list;
  }
}
